import { useEffect } from 'react';
import { Html5QrcodeScanner, Html5QrcodeScanType, QrcodeSuccessCallback } from 'html5-qrcode';
import { Html5QrcodeScannerConfig } from 'html5-qrcode/esm/html5-qrcode-scanner';

const qrcodeRegionId = "html5qr-code-full-region";

type QrScannerProps = {
  config: Html5QrcodeScannerConfig;
  verbose?: boolean;
  qrCodeSuccessCallback: QrcodeSuccessCallback;
}

const QrScanner = ({ config, verbose = true, qrCodeSuccessCallback }: QrScannerProps) => {

  useEffect(() => {
    const html5QrcodeScanner = new Html5QrcodeScanner(qrcodeRegionId, {...config, supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]}, verbose);
    html5QrcodeScanner.render(qrCodeSuccessCallback, undefined);

    return () => {
      html5QrcodeScanner.clear().catch(error => {
        console.warn("Failed to clear html5QrcodeScanner. ", error);
      });
    };
    
  }, [config, qrCodeSuccessCallback, verbose]);

  return (
    <div id={qrcodeRegionId} />
  );
};

export default QrScanner;